import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { IKeepInTouchSystemJob } from '../../models/KeepInTouchAgent';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useRunKeepInTouchJob = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: IKeepInTouchSystemJob) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (configId: string) => {
			return userSession.webServiceHelper.callAsync<IKeepInTouchSystemJob>(
				`KeepInTouchJobConfiguration/${configId}/run`,
				'POST',
				null
			);
		},
		onError,
		onSuccess,
	});
};
